/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useState, useEffect} from 'react';
import {useFormik} from 'formik';
import {logoutUser} from '@app/store/reducers/auth';
import {toast} from 'react-toastify';
import {ContentHeader} from '@components';
import {intervalToDuration, setMilliseconds} from 'date-fns';
import {useNavigate} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import {createLeave, fetchAllLeaveDetails} from '@app/services/leaves';
import {getAllAdminName} from '../../services/leaves';
import handleStatus from '../../utils/ajax';
import {LeaveInfoContainer} from './leaveInfoComponent';
import {calculateBusinessDays} from '../../utils/leaveDateCalculation';

const ApplyLeave = () => {
  const [users, setUsers] = useState([]);
  // const [interval, setInterval] = useState({});
  // const [styleForValidaiton] = useState({color: 'red'});
  const [leaveStartDate, setLeaveStartDate] = useState(0);
  const [leaveEndDate, setLeaveEndDate] = useState(0);
  const [leaveDetails, setLeaveDetails] = useState({}) as any;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const initialValues = {
    leaveType: '',
    leaveDuration: '',
    leaveStartDate: '',
    leaveEndDate: '',
    reason: '',
    halfLeave: '',
    reportedTo: ''
  };

  useEffect(() => {
    const getLeaveDetails = async () => {
      try {
        const response = await fetchAllLeaveDetails(); // Call the fetchAllLeaveDetails function
        // console.log(response, 'response fetch all leave data===========');
        if (response.status === 200 && response.data.ok) {
          setLeaveDetails(response?.data?.data); // Set the leave details to state
        } else {
          toast.warn('Failed to fetch leave details');
        }
      } catch (error) {
        toast.error('Error fetching leave details');
      }
    };

    getLeaveDetails();
  }, []);

  const onSubmit = async (values: any) => {
    try {
      if (values.leaveStartDate && values.leaveEndDate) {
        const dateStart = values.leaveStartDate.split('-');
        const updatedDateStart = ` ${dateStart[2]}/${dateStart[1]}/${dateStart[0]}`;
        values.leaveStartDate = updatedDateStart;

        const dateEnd = values.leaveEndDate.split('-');
        const updatedDateEnd = `${dateEnd[2]}/${dateEnd[1]}/${dateEnd[0]}`;
        values.leaveEndDate = updatedDateEnd;
      }

      if (values.leaveDuration.toLowerCase() === 'half day') {
        values.halfLeave = '0.5';
        const dateStart = values.leaveStartDate.split('-');
        const updatedDateStart = `${dateStart[2]}/${dateStart[1]}/${dateStart[0]}`;
        values.leaveStartDate = updatedDateStart;
        values.leaveEndDate = updatedDateStart;
      }

      if (values.leaveDuration.toLowerCase() === 'a full day') {
        const dateStart = values.leaveStartDate.split('-');
        const updatedDateStart = `${dateStart[2]}/${dateStart[1]}/${dateStart[0]}`;
        values.leaveStartDate = updatedDateStart;
        values.leaveEndDate = updatedDateStart;
      }

      if (!calculateBusinessDays(leaveStartDate, leaveEndDate)) {
        toast.warn('Your are not applied for weekend.');
        return;
      }

      const resp = await createLeave(values);
      // console.log(resp, 'respnonse==============');

      if (!resp.data.ok) {
        toast.warn(
          resp?.data?.error ||
            resp?.data?.message ||
            'Something went wrong while applying leave'
        );
        setLeaveStartDate(0);
        setLeaveEndDate(0);
        values.leaveStartDate = '';
        values.leaveEndDate = '';
        navigate('/apply-leave');
        return;
      }

      handleStatus(resp.status, () => dispatch(logoutUser()), navigate);

      if (resp.status === 200) {
        toast.success('Leave Created Successfully');
        navigate('/my-leaves');
      }
    } catch (error) {
      toast.error('There was an issue applying leave. Please try again.');
    }
  };

  const getAllAdmin = async () => {
    try {
      const res = await getAllAdminName();
      handleStatus(res.status, () => dispatch(logoutUser()), navigate);

      if (res.data.ok) {
        setUsers(
          res.data.data.map(({_id: id, name}: any) => ({
            value: id,
            label: name
          }))
        );
      }
    } catch (error: any) {
      console.error('Error while getting all admin name.');
    }
  };

  const handleChange = (val: any) => {
    formik.values.leaveStartDate = val;

    if (formik.values.leaveStartDate) {
      const leaveStartDateInTimestamps = new Date(
        formik.values.leaveStartDate
      ).getTime();

      setLeaveStartDate(leaveStartDateInTimestamps);
    }
  };

  const handleChange1 = (val1: any) => {
    formik.values.leaveEndDate = val1;
    if (formik.values.leaveEndDate) {
      const leaveEndDateInTimestamps = new Date(
        formik.values.leaveEndDate
      ).getTime();
      setLeaveEndDate(leaveEndDateInTimestamps);
    }
  };

  const daysDiff = (startDate: number, endDate: number) => {
    if (startDate !== 0 && endDate !== 0) {
      if (endDate < startDate) {
        return {
          error: true,
          text: 'Leave end date can not be less than start date'
        };
      }

      const diff = intervalToDuration({
        start: new Date(startDate),
        end: new Date(endDate)
      });

      const daysExcludedWeekDays = calculateBusinessDays(startDate, endDate);
      const {days, months} = diff;

      if (months > 0 && days === 0) {
        diff.days = daysExcludedWeekDays;
      }

      if (months === 0 && days >= 0) {
        diff.days = daysExcludedWeekDays;
      }

      return {
        days: diff.days,
        months: diff.months,
        daysText: diff.days === 1 ? ' day' : ' days',
        monthsText: diff.months === 1 ? ' month' : ' months'
      };
    }
  };

  const validate = (values: any) => {
    const errors = {} as any;
    if (!values.leaveType || values.leaveType === 'select') {
      errors.leaveType = 'Please select your leave type';
    }
    if (!values.leaveDuration || values.leaveDuration === 'select') {
      errors.leaveDuration = 'Please select your leave duration';
    }
    if (!values.leaveStartDate) {
      errors.leaveStartDate = 'Please select your leave start date';
    }
    if (values.leaveDuration.toLowerCase() === 'multiple days') {
      if (!values.leaveEndDate) {
        errors.leaveEndDate = 'Please select your leave end date';
      }
    }
    if (!values.reportedTo || values.reportedTo === 'select') {
      errors.reportedTo = 'Please select an option to whom you reported';
    }
    if (!values.reason) {
      errors.reason = 'Please enter appropriate reason';
    } else if (values.reason.length < 20) {
      errors.reason = 'Minimum 20 characters required';
    }
    return errors;
  };

  useEffect(() => {
    getAllAdmin();
  }, []);

  const formik = useFormik({
    initialValues,
    onSubmit,
    validate
  });

  const daysDifference = daysDiff(leaveStartDate, leaveEndDate);

  const renderApplyLeaveDays = (daysDifference) => {
    const differnce = {...daysDifference};
    if (Object.keys(differnce).length === 0) {
      differnce.days = 0;
      differnce.months = 0;
      differnce.monthsText = '';
      differnce.daysText = '';
    }
    const {days, months, monthsText, daysText} = differnce;
    const month = months === 0 ? '' : `${months} ${monthsText}`;
    const day = days === 0 ? '' : `${days} ${daysText} `;
    const and = months > 0 && days > 0 ? ' and ' : '';

    if (leaveStartDate && leaveEndDate) {
      if (daysDifference.error) {
        return <div style={{color: 'red'}}>{daysDifference.text}</div>;
      }

      return (
        <div className="warning-message">
          {' '}
          You are applying for {month} {and} {day} leave
        </div>
      );
    }

    return null;
  };

  const disableSubmit = daysDifference?.error || daysDifference?.value === 0;
  console.log(daysDifference, 'daysDifference');
  // const leaveFormatted = formatLeaveStatus()
  return (
    <div>
      <ContentHeader title="Apply Leaves" />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-header" style={{marginBottom: '10px'}}>
              <h3 className="card-title">Please Enter the Information</h3>
            </div>
            <LeaveInfoContainer
              totalLeaves={leaveDetails.totalLeaves}
              appliedLeaves={leaveDetails.appliedLeaves}
              remainingLeaves={leaveDetails.remainingLeaves}
              isLeaveExceeded={leaveDetails.isLeaveExceeded}
              totalPaidLeave={leaveDetails?.totalPaidLeave}
              totalUnpaidLeave={leaveDetails?.totalUnpaidLeave}
            />
            <div className="card-body">
              <div className="col-md-12">
                <form onSubmit={formik.handleSubmit}>
                  {/* <div className="row">
                    <label
                      htmlFor="inputName"
                      className="col-sm-2 col-form-label"
                    >
                      User Name
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="text"
                        className="form-control"
                        id="inputName"
                        placeholder="Name"
                        name="name"
                        maxLength={30}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                      />
                      {formik.touched.name && formik.errors.name ? (
                        <div style={{color: 'red'}}>{formik.errors.name}</div>
                      ) : null}
                    </div>
                  </div> */}

                  <div className="row">
                    <label
                      htmlFor="inputSkills"
                      className="col-sm-2 col-form-label"
                    >
                      Leave Type
                    </label>
                    <div className="col-sm-10">
                      <select
                        className="form-control"
                        name="leaveType"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.leaveType}
                      >
                        <option value="select">Select an option...</option>
                        <option>Vacation</option>
                        <option>Medical</option>
                        <option>Other</option>
                      </select>
                      {formik.touched.leaveType && formik.errors.leaveType ? (
                        <div style={{color: 'red'}}>
                          {formik.errors.leaveType}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <label
                      htmlFor="inputSkills"
                      className="col-sm-2 col-form-label"
                    >
                      Leave Duration
                    </label>
                    <div className="col-sm-10">
                      <select
                        className="form-control"
                        name="leaveDuration"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.leaveDuration}
                      >
                        <option value="select">Select an option...</option>
                        <option>Half Day</option>
                        <option>A full day</option>
                        <option>Multiple days</option>
                      </select>
                      {formik.touched.leaveDuration &&
                      formik.errors.leaveDuration ? (
                        <div style={{color: 'red'}}>
                          {formik.errors.leaveDuration}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <label
                      htmlFor="inputSkills"
                      className="col-sm-2 col-form-label"
                    >
                      Leave Start Date
                    </label>
                    <div className="col-sm-10">
                      <input
                        type="date"
                        className="form-control datetimepicker-input"
                        data-target="#reservationdate"
                        name="leaveStartDate"
                        onChange={(e) => handleChange(e.target.value)}
                        onBlur={formik.handleBlur}
                        value={formik.values.leaveStartDate}
                      />
                      {formik.touched.leaveStartDate &&
                      formik.errors.leaveStartDate ? (
                        <div style={{color: 'red'}}>
                          {formik.errors.leaveStartDate}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  {(formik.values.leaveDuration === '' ||
                    formik.values.leaveDuration.toLowerCase() ===
                      'multiple days') && (
                    <div className="row">
                      <label
                        htmlFor="inputSkills"
                        className="col-sm-2 col-form-label"
                      >
                        Leave End Date
                      </label>
                      <div className="col-sm-10">
                        <input
                          type="date"
                          className="form-control datetimepicker-input"
                          data-target="#reservationdate"
                          name="leaveEndDate"
                          onChange={(e) => handleChange1(e.target.value)}
                          onBlur={formik.handleBlur}
                          value={formik.values.leaveEndDate}
                        />
                        {formik.touched.leaveEndDate &&
                        formik.errors.leaveEndDate ? (
                          <div style={{color: 'red'}}>
                            {formik.errors.leaveEndDate}
                          </div>
                        ) : null}
                        {renderApplyLeaveDays(daysDifference)}
                      </div>
                    </div>
                  )}

                  <div className="row">
                    <label
                      htmlFor="inputSkills"
                      className="col-sm-2 col-form-label"
                    >
                      Reason
                    </label>
                    <div className="col-sm-10">
                      <textarea
                        className="form-control"
                        id="inputSkills"
                        placeholder="Reason"
                        name="reason"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.reason}
                      />
                      {formik.touched.reason && formik.errors.reason ? (
                        <div style={{color: 'red'}}>{formik.errors.reason}</div>
                      ) : null}
                    </div>
                  </div>
                  <div className="row">
                    <label
                      htmlFor="inputSkills"
                      className="col-sm-2 col-form-label"
                    >
                      Reported To
                    </label>

                    <div className="col-sm-10">
                      <select
                        className="form-control"
                        name="reportedTo"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.reportedTo}
                      >
                        <option value="select">Select an option...</option>
                        {users.map((user: any) => {
                          return (
                            <>
                              <option key={user?._id} value={user?.value}>
                                {user.label}
                              </option>
                            </>
                          );
                        })}
                      </select>
                      {formik.touched.reportedTo && formik.errors.reportedTo ? (
                        <div style={{color: 'red'}}>
                          {formik.errors.reportedTo}
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <button
                    type="submit"
                    disabled={disableSubmit}
                    className="btn btn-primary offset-md-2"
                  >
                    Submit
                  </button>
                </form>
              </div>
            </div>
            {/* <div className="card-footer">Footer</div> */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default ApplyLeave;
